/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CpoeDeckAliases {
  CARDCONTAINER_DIALYSIS = 'cardcontainer-dialysis',
  CARDCONTAINER_EXAMS_AND_PROCEDURES = 'cardcontainer-exams-and-procedures',
  CARDCONTAINER_GASTHERAPY = 'cardcontainer-gastherapy',
  CARDCONTAINER_HEMOTHERAPY = 'cardcontainer-hemotherapy',
  CARDCONTAINER_INFUSION_MEDICINS = 'cardcontainer-infusion-medicins',
  CARDCONTAINER_NURSING_INTERVENTIONS = 'cardcontainer-nursing-interventions',
  CARDCONTAINER_NUTRITION = 'cardcontainer-nutrition',
  CARDCONTAINER_RECOMMENDATIONS = 'cardcontainer-recommendations',
  CONTEXTUAL_BAR_TIMELINE = 'contextual-bar-timeline',
  DATE_CPOE_FILTER = 'date-cpoe-filter',
  DECK_DIALYSIS = 'deck-dialysis',
  DECK_EXAMS_AND_PROCEDURES = 'deck-exams-and-procedures',
  DECK_GAS_THERAPY = 'deck-gas-therapy',
  DECK_HEMOTHERAPY = 'deck-hemotherapy',
  DECK_INFUSION_MEDICINS = 'deck-infusion-medicins',
  DECK_NURSING_INTERVENTIONS = 'deck-nursing-interventions',
  DECK_NUTRITION = 'deck-nutrition',
  DECK_RECOMMENDATIONS = 'deck-recommendations',
  FETCH_DIALYSIS = 'fetch-dialysis',
  FETCH_EXAMS_AND_PROCEDURES = 'fetch-exams-and-procedures',
  FETCH_GAS_THERAPY = 'fetch-gas-therapy',
  FETCH_HEMOTHERAPY = 'fetch-hemotherapy',
  FETCH_INFUSION_MEDICINS = 'fetch-infusion-medicins',
  FETCH_NURSING_INTERVENTIONS = 'fetch-nursing-interventions',
  FETCH_NUTRITION = 'fetch-nutrition',
  FETCH_RECOMMENDATIONS = 'fetch-recommendations',
  FIELD_CPOE_FILTER_DATE = 'field-cpoe-filter-date',
  FIELD_CPOE_FILTER_HOUR = 'field-cpoe-filter-hour',
  IDENTIFIABLE_DIALYSIS = 'identifiable-dialysis',
  IDENTIFIABLE_EXAMS = 'identifiable-exams',
  IDENTIFIABLE_GAS_THERAPY = 'identifiable-gas-therapy',
  IDENTIFIABLE_HEMOTHERAPY = 'identifiable-hemotherapy',
  IDENTIFIABLE_INFUSION = 'identifiable-infusion',
  IDENTIFIABLE_INTERVENTATIONS = 'identifiable-interventations',
  IDENTIFIABLE_NUTRITION = 'identifiable-nutrition',
  IDENTIFIABLE_RECOMMENDATIONS = 'identifiable-recommendations',
  LAYOUT_CPOE = 'layout-cpoe',
  LEGENDS_ALL_GROUPS = 'legends-all-groups',
  MAPPER_DIALYSIS = 'mapper-dialysis',
  MAPPER_EXAMS_AND_PROCEDURES = 'mapper-exams-and-procedures',
  MAPPER_GAS_THERAPY = 'mapper-gas-therapy',
  MAPPER_HEMOTHERAPY = 'mapper-hemotherapy',
  MAPPER_INFUSON_MEDICINE = 'mapper-infuson-medicine',
  MAPPER_NURSING_INTERVENTIONS = 'mapper-nursing-interventions',
  MAPPER_NUTRITION = 'mapper-nutrition',
  MAPPER_RECOMMENDATIONS = 'mapper-recommendations',
  PANEL_CPOE_ALL_GROUPS = 'panel-cpoe-all-groups',
  PANEL_CPOE_CARDCONTAINER = 'panel-cpoe-cardcontainer',
  PANEL_CPOE_FILTER_DATE = 'panel-cpoe-filter-date',
  PANEL_CPOE_FILTER_HOUR = 'panel-cpoe-filter-hour',
  PANEL_DIALYSIS = 'panel-dialysis',
  PANEL_EXAMS_PROCEDURES = 'panel-exams-procedures',
  PANEL_GAS_THERAPY = 'panel-gas-therapy',
  PANEL_HEMOTHERAPY = 'panel-hemotherapy',
  PANEL_INFUSION_MEDICINS = 'panel-infusion-medicins',
  PANEL_NURSING_INTERVENTIONS = 'panel-nursing-interventions',
  PANEL_NUTRITION = 'panel-nutrition',
  PANEL_RECOMMENDATIONS = 'panel-recommendations',
  SECTION_DIALYSIS = 'section-dialysis',
  SECTION_EXAMS_PROCEDURES = 'section-exams-procedures',
  SECTION_GASTHERAPY = 'section-gastherapy',
  SECTION_HEMOTHERAPY = 'section-hemotherapy',
  SECTION_INFUSION_MEDICINS = 'section-infusion-medicins',
  SECTION_NURSING_INTERVENTIONS = 'section-nursing-interventions',
  SECTION_NUTRITION = 'section-nutrition',
  SECTION_RECOMMENDATIONS = 'section-recommendations',
  SORTABLE_CPOE = 'sortable-cpoe',
  SUPPRESS_DIALYSIS = 'suppress-dialysis',
  SUPPRESS_EXAMS = 'suppress-exams',
  SUPPRESS_GASTHERAPY = 'suppress-gastherapy',
  SUPPRESS_HEMOTHERAPY = 'suppress-hemotherapy',
  SUPPRESS_INFUSION_MEDICINS = 'suppress-infusion-medicins',
  SUPPRESS_NURSING_INTERVENTIONS = 'suppress-nursing-interventions',
  SUPPRESS_NUTRITION = 'suppress-nutrition',
  SUPPRESS_RECOMMENDATIONS = 'suppress-recommendations',
  TIME_CPOE_FILTER = 'time-cpoe-filter',
}
export { CpoeDeckAliases };
